import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { IrisDmsSidebarSandbox } from '@iris/common/modules/dms/sandbox/dms-sidebar.sandbox';
import { IrisDmsFilesSandbox } from '@iris/common/modules/dms/sandbox/dms-files.sandbox';
import { DmsGridTemplateBase } from '../dms-grid-template-base';
import { TranslatePipe } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IrisDmsTrashBinRestoreButtonComponent } from '../../components/dms-bulk-actions/dms-trash-bin-restore-button/dms-trash-bin-restore-button.component';
import { IrisDmsDownloadFolderButtonComponent } from '@iris/common/modules/dms/components/actions/folder-actions/dms-download-folder-button/dms-download-folder-button.component';
import { IrisDmsEditOfficeFileButtonComponent } from '../../components/file-actions/dms-edit-office-file-button/dms-edit-office-file-button.component';
import { IrisDmsFilePreviewButtonComponent } from '../../components/file-actions/dms-file-preview-button/dms-file-preview-button.component';
import { IrisDmsDownloadFileButtonComponent } from '../../components/file-actions/dms-download-file-button/dms-download-file-button.component';
import { StrakitClickStopPropagationDirective } from '@ngx-strakit/cdk';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';

@Component({
  selector: 'iris-dms-grid-trash-bin-actions-template',
  imports: [
    TranslatePipe,
    MatTooltipModule,

    IrisDmsTrashBinRestoreButtonComponent,
    IrisDmsDownloadFolderButtonComponent,
    IrisDmsDownloadFileButtonComponent,
    IrisDmsEditOfficeFileButtonComponent,
    IrisDmsFilePreviewButtonComponent,

    StrakitButtonComponent,
    StrakitClickStopPropagationDirective,
  ],
  templateUrl: './dms-grid-trash-bin-actions-template.component.html',
  styleUrls: ['./dms-grid-trash-bin-actions-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsGridTrashBinActionsTemplateComponent extends DmsGridTemplateBase {
  private readonly dmsSidebarSandbox = inject(IrisDmsSidebarSandbox);
  private readonly dmsFilesSandbox = inject(IrisDmsFilesSandbox);

  readonly isOfficeEditableDocument = computed(() => this.dmsFilesSandbox.isFileEditable(this.file()));

  refresh(): boolean {
    return true;
  }

  openFolderInfo(): void {
    this.dmsSidebarSandbox.showFolderSidebar(this.folder().id);
  }

  openFileInfo(): void {
    this.dmsSidebarSandbox.showFileSidebar(this.file().id);
  }
}
